import util from '../../utils/util';

/**
 * @param {string} list - list
 * @param {string} pageType - page type
 * @param {Array} products - products
 * @returns {void}
 */
export default async (list, pageType, products) => {
    if (window.dataLayer) {
        const productIds = products.slice(0, 3).map(p => p.ID);
        const params = {
            list,
            pageType,
            productIds,
            format: 'ajax'
        };

        const url = util.appendParamsToUrl(Urls.getEcommerceImpressions, params);

        const impressionsResponse = await fetch(url);

        if (impressionsResponse) {
            const respText = await impressionsResponse.text();

            if (respText) {
                const ecommerce = {
                    ecommerce: {
                        impressions: JSON.parse(respText)
                    }
                };

                window.dataLayer.push(ecommerce);
            }
        }
    }
};
